// @flow

// Setting route pins associates the pins loaded into a grid with the page on
// which that grid lives.

import type { HistoryLocation } from 'app/common/redux/actions/history';

export type SetRoutePinsAction = {|
  type: 'SET_ROUTE_PINS',
  payload: {
    location: HistoryLocation,
    routePins: ?Array<string>,
  },
|};

const isPin = (item: Object) => item && item.type === 'pin';
export const getPinIdsFromItems = (gridItems: any): Array<string> =>
  gridItems.filter(isPin).map((pin) => pin.id);

export const setRoutePins = (
  routePins: ?Array<string>,
  location: HistoryLocation,
): SetRoutePinsAction => ({
  type: 'SET_ROUTE_PINS',
  payload: {
    location,
    routePins,
  },
});

export default undefined;
